import { HeroSection } from './heroSection';
import { SecondSection } from './secondSection';
import { ThirdSection } from './thirdSection';
import { FourthSection } from './fourthSection';
import { FifthSection } from './fifthSection';
import { SixthSection } from './sixthSection';
import { SeventhSection } from './seventhSection';
import { EighthSection } from './eighthSection';
import { NinthSection } from './ninthSection';
import { TenthSection } from './tenthSection';
const components = {
    heroSection: HeroSection,
    secondSection: SecondSection,
    thirdSection: ThirdSection,
    fourthSection: FourthSection,
    fifthSection: FifthSection,
    sixthSection: SixthSection,
    seventhSection: SeventhSection,
    eighthSection: EighthSection,
    ninthSection: NinthSection,
    tenthSection: TenthSection
}
export function Landing(props: any) {
    return (
        <div className='page-landing-tanqueray'>
            {
                Object.keys(props).filter((key) => key in components).map((key) => {
                    const Component = components[key as keyof typeof components];
                    return <Component key={key} {...props[key]} />
                })
            }
        </div>
    );
}